<template>
  <div id="calendar-index" class="well">
    <p>Choosing a calendar view...</p>
  </div>
</template>

<script>
import { ROUTES, CALENDAR_ROUTE_DEFAULT, getCalendarRoute } from "./config";

export default {
  name: "CalendarIndex",
  props: {
    items: {
      type: Array,
      required: true,
    },
    itemsByDate: {
      type: Object,
      required: true,
    },
    pageDate: {
        type: String,
        required: true,
    },
    eventDates: {
        type: Array,
        required: true,
    },
    activeDates: {
        type: Array,
        required: true,
    },
    itineraryDates: {
        type: Array,
        required: true,
    },
    event: {
      type: Object,
      required: true,
    },
    timezone: {
      type: String,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
    me: {
      type: Object,
      required: false,
    },
  },
  created() {
    // Check what the default or last view was and bounce to it
    // TODO: Add code to find relevant Setting
    // TODO: Add code to handle routes that get removed e.g. 1 day event doesn't need week/month views

    if (Object.keys(this.itemsByDate).length==0 && this.filters.slotless.length>=1) {
        // Empty calendar, probably AUTO_SELECT_MEETING_SLOT=True
        this.$router.push({ name: ROUTES.QUEUED });
    } else {
        this.$router.push({ name: getCalendarRoute(CALENDAR_ROUTE_DEFAULT) });
    }
    
  },
};
</script>

<style>
</style>